module.exports = __webpack_public_path__ + "img/m-3.33761fab.png";